/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import "../../../assets/css/HTML.scss"
import { DotsNavigationContent, ILandingSection } from "../../../data/interfaces"
import DotsNavigationPrimitive from "../primitive/DotsNavigationPrimitive"
import Dummy from "./Dummy"

/* Protopia Ecosystem component */
export interface IHTMLProps {
   section: ILandingSection
   data: DotsNavigationContent 
}
const DotsNavigation = ({data, ...props}: IHTMLProps): JSX.Element => {     
    useEffect(() => {
        addCSSClass(
            `landing-dots-navigation-${props.section.id}`,
            `.landing-dots-navigation-${props.section.id} {
                
            }
            `
        )
        
        return () => {
            removeCSSClass(`landing-dots-navigation-${props.section.id}`)
        }
    },[ ])
  
    // console.log( data )
  
    return <div className={`pe-dots-navigation-container landing-content-container`} data-type={data.type} data-content-id={data.id}>
        {
            !!data.items.length
                ?
                <DotsNavigationPrimitive
                    primitive={{
                            ...(data ), 
                    } as any }
                />
                :
                <Dummy {...{ 
                    ...{
                        data: {
                            ...data,
                            className: ` ${data.className} landing-navigation-container-${props.section.id} `
                    },
                    }, 
                    ...props 
                }} />
        }
        
    </div>
}
export default DotsNavigation